"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOkta = exports.setupRefresh = exports.handleLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _oktaAuthJs = _interopRequireDefault(require("@okta/okta-auth-js"));
var _queryString = _interopRequireDefault(require("query-string"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var handleLogin = function handleLogin(authClient, onLogin) {
  authClient.tokenManager.get("accessToken").then(function (tokens) {
    var windowHash = window.location.hash;
    if (tokens) {
      onLogin();
    } else if (windowHash) {
      authClient.token.parseFromUrl().then(function (token) {
        token.forEach(function (t) {
          if (t.idToken) {
            authClient.tokenManager.add("idToken", t);
          }
          if (t.accessToken) {
            authClient.tokenManager.add("accessToken", t);
          }
        }); //parse url

        var param = _queryString["default"].parse(windowHash);
        var state = decodeURIComponent(param.state);
        onLogin(state);
      });
    } else {
      authClient.token.getWithRedirect({
        responseType: ["token", "id_token"],
        scopes: ["openid", "profile", "email", "groups"],
        expireEarlySeconds: 120,
        nonce: "uSeRInfo",
        state: encodeURIComponent(window.location.pathname + window.location.search)
      });
    }
  });
  authClient.tokenManager.get("idToken");
};
exports.handleLogin = handleLogin;
var setupRefresh = function setupRefresh(authClient) {
  authClient.tokenManager.on("expired", function () {
    authClient.tokenManager.get("accessToken");
    authClient.tokenManager.get("idToken");
  });
};
exports.setupRefresh = setupRefresh;
var useOkta = function useOkta(config, onLogin) {
  var _useState = (0, _react.useState)({
      loginFunction: function loginFunction() {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    loginFunction = _useState2[0],
    setLoginFunction = _useState2[1];
  (0, _react.useEffect)(function () {
    if (config) {
      var authClient = new _oktaAuthJs["default"]({
        url: config.url,
        clientId: config.clientId,
        issuer: config.issuer,
        redirectUri: config.redirectUri,
        autoRenew: true
      });
      setupRefresh(authClient);
      handleLogin(authClient, onLogin);
      var loginFunc = function loginFunc() {
        return handleLogin(authClient, onLogin);
      };
      setLoginFunction({
        loginFunction: loginFunc
      });
    }
  }, [config]);
  return loginFunction;
};
exports.useOkta = useOkta;